import { Directive, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[noWhiteSpace]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NoWhiteSpaceDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class NoWhiteSpaceDirective {
  // @Input('noWhiteSpace') validationNeeded : boolean;

  validator: Function;

  constructor() {
    // this.validator = validateNoWhiteSpace
  }

  validate(control: UntypedFormControl) {
    // if(!control?.value)return null
    // return this.validationNeeded ? this.validator(control) : null
    // return this.validator(control)

    let WHITE_SPACE_REGEX = new RegExp(/\s/);

    return WHITE_SPACE_REGEX.test(control.value)
      ? {
          noWhiteSpace: true,
        }
      : null;
  }
}

// export function validateNoWhiteSpace(control: FormControl) {
//     let WHITE_SPACE_REGEX = new RegExp(/\s/)

//     return WHITE_SPACE_REGEX.test(control.value) ? {
//         noWhiteSpace: true
//     } : null;
// }
